// data/governingBodyData.js
export const governingBodyData = {
  // Optional: if you have a chairperson/head
  // chairperson: {
  //   id: "gb-chair",
  //   name: "H.E. Prof. (Dr.) K. C. Jankee",
  //   designation: "President, WASME",
  //   image: "/img/presidentnew.jpg",
  //   message: "Cooperation and collective effort are the cornerstones of progress.",
  //   fullProfile: {
  //     bio: "Detailed biography...",
  //     // other fields
  //   }
  // },
 members : [
  {
    id: "gb-member1",
    name: "H.E. Prof. (Dr.) K. C. Jankee",
    designation: "President, WASME",
    image: "/img/presidentnew.jpg",
    shortBio:
      "Former Ambassador of Mauritius to Russia & Germany; economist and academic with global policy experience.",
    fullProfile: {
      bio: `Prof. Dr. Kheswar Jankee served as Ambassador of Mauritius to the Russian Federation and Germany (2014–2024). He has been honored with the Grand Order of the Officer of the Star and Key of the Indian Ocean for his contributions to tertiary education and economic policy making.

He began his career as a college teacher and later worked as an economist at the Ministry of Economic Planning and the Bank of Mauritius. He also lectured at the University of Mauritius and earned his Ph.D., publishing numerous research papers and book chapters.

Dr. Jankee has worked with international organizations including AUC, AERC, World Bank, and SADC. He currently serves as President of WASME (Delhi) and Founder President of AAASME (Nigeria).`
    }
  },
  {
    id: "gb-member2",
    name: "Mr. Dumisani J. Msibi",
    designation: "Vice President, WASME",
    image: "/img/Misibi.jpg",
    shortBio:
      "Group Managing Director, FINCORP; expert in banking, development finance, and institutional leadership.",
    fullProfile: {
      bio: `Mr. Dumisani J. Msibi is an Accountant with extensive experience in banking and finance. He joined FINCORP in 1997 and has served in multiple leadership roles including Deputy Managing Director and General Manager of First Finance.

He played a key role in transforming FINCORP into a reputable development finance institution. He is Vice Chairman of the SADC DFI Network and Executive Committee Member of AADFI representing Southern Africa. He also serves on the Board of FSE & CC and previously chaired the Youth Enterprise Fund.`
    }
  },
  {
    id: "gb-member3",
    name: "Mr. Friday Okpara",
    designation: "Vice President, WASME",
    image: "/img/friday.jpg",
    shortBio:
      "Entrepreneurship educator and SME development specialist; Director at SMEDAN, Nigeria.",
    fullProfile: {
      bio: `Dr. Friday Okpara is an Entrepreneurship Educator and Small Business Development Specialist. He founded and continues to patronize the Entrepreneurship Club at the University of Abuja.

He has served as Lecturer at the University of Abuja and Assistant Professor at the University of Gondar, Ethiopia. He is President of CEDSBM and Mega-Top Management Ltd.

He chairs major entrepreneurship initiatives including TIEDEP and drives the Mind Shift Entrepreneurship Programme of SMEDAN. He also serves as a member of CBNTIES and advisory boards in Nigeria and the USA.`
    }
  },
  {
    id: "gb-member4",
    name: "Mr. Rajesh Kazi Shrestha",
    designation: "Vice President, WASME",
    image: "/img/Mr.Rajesh_Kazi .png",
    shortBio:
      "Mr. Rajesh Kazi Shrestha is a prominent leader in Nepal’s business and industrial sector.",
    fullProfile: {
      bio: `Mr. Rajesh Kazi Shrestha is a prominent leader in Nepal’s business and industrial sector, recognized as a Commercially Important Person (CIP) for his outstanding contributions. He is the Chairperson of the Advisory Council of Nepal Chamber of Commerce, having also served as its Past President, and is the President of the International Chamber of Commerce, Nepal. He holds several key positions, including Honorary Consul of the Socialist Republic of Vietnam to Nepal, Honorary President of the Nepal China Chamber of Commerce & Industry, and Immediate Past President of the Nepal Vietnam Chamber of Commerce & Industry. Mr. Shrestha has been widely honored by the Government of Nepal and industry associations for his contributions to trade, entrepreneurship, and the development of Nepal’s commerce and industry.`
    }
  },
  {
    id: "gb-member5",
    name: "Mr. S M Zillur Rahman",
    designation: "Vice President, Bangladesh",
    image: "/img/zillur.jpg",
    shortBio:
      "Chairman & CEO, Rahman Group; entrepreneur in textiles, manpower, and global trade.",
    fullProfile: {
      bio: `Mr. Rahman is a full-time businessman involved in textile and ready-made garment manufacturing, international manpower recruitment, real estate, hospitality, trading, and export-import businesses.

He actively builds international partnerships and focuses on ethical business practices. His interests include global collaboration in RMG, recruitment, consultancy, joint ventures, and partnership opportunities with Bangladesh Government initiatives.`
    }
  },
  {
    id: "gb-member6",
    name: "CA (Dr.) Indra D. Narayan",
    designation: "Vice President – Asia, WASME",
    image: "/img/narayan.jpg",
    shortBio:
      "Senior Chartered Accountant expertise in taxation, governance.",
    fullProfile: {
      bio: `CA (Dr.) Indra D. Narayan is Founder and Senior Partner of Indra D. Narayan & Co. With over 27 years of professional experience, he specializes in Direct Taxation, Corporate Governance, Company Law matters, audits, mergers and acquisitions, and business advisory services.

A fellow member of ICAI and an active Rotarian, he participates in international professional bodies focused on business development and education. He is also associated with charitable organizations supporting underprivileged and disabled children.`
    }
}
  
]
};